import React from 'react'

export default function RetailCoifficientCol(props) {
  return (
    <>{props.coefficient ? props.coefficient.toFixed(2) : ""} {props.coefficient ? "x" : "--"}</>
  )
}
